@if (animationState) {
  <div [@fadeIn]>
    <app-dynamic></app-dynamic>
  </div>
}
